import { useApiStore } from "@/stores/api/index.ts";
import getDefaultOpts from "@/store/utils/getDefaultOpts.js";

const fetchStylingData = async (module, payload = {}) => {
  const api = useApiStore();
  const { dispatch } = module;
  const opts = payload.opts ?? {};
  const config = Object.assign(
    getDefaultOpts(),
    {
      isCms: false,
      isAuth: false,
    },
    opts
  );
  const { data } = await dispatch("httpRequest", {
    func: api.fetchStylingData(),
    config,
  });
  await module.dispatch("setDefaultSiteId", data.defaultSiteId, { root: true });
  await module.dispatch("setStyleID", data.siteID, { root: true });
  await module.dispatch("setClientID", data.clientID, { root: true });
  await module.dispatch("setStylingData", data, { root: true });
  await module.dispatch("setOrganizationName", data.styleName, { root: true });
  await module.dispatch("setIsActivated", data.isActivated, { root: true });
  await module.dispatch("setCsDetails", data.csDetails, { root: true });

  await module.dispatch(
    "setPageData",
    { pageName: "Home", data },
    { root: true }
  );
  await module.commit("storeHomeData", data);
};

export { fetchStylingData };
